
import React, { useState,useEffect } from 'react';
import { Switch, Modal, Button ,Typography} from 'antd';
import { connect } from 'react-redux'
import '../../../css/patient.scss'
import { togglePatientStatus,setActionDisabled,getPatient } from '../../../store/action/patient.action';
const { Text, Title } = Typography

const PatientActiveModal = (props) => {
  const [isActive, setIsActive] = useState(true); // Default active state
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(()=>{
    if(!props.activeState) setIsActive(false)
    else  setIsActive(true)
  },[props.activeState])
  useEffect(() => {
    return () => {
      props.setActionDisabled(true);
    };
  }, []);

  const handleToggle = (checked,e) => {
    e.stopPropagation();
    if (!checked) {
      // If turning OFF, show confirmation modal
      setIsModalVisible(true);
    } else {
        togglePatient(true)
    }
  };

  const handleConfirmDeactivate = () => {
    togglePatient(false);
    setIsModalVisible(false);
  };
  const togglePatient=(isActive)=>{
    try{
      props.togglePatientStatus({patientId:props._id,isActive}).then(res=>{
        if(res?.status)setIsActive(isActive);
        props.getPatient(props._id);
        // props.setActionDisabled(false);
      }).catch(err=>{
         console.log(err)
      });
  
    }
    catch(err){
        console.log(err,"Error in togglePatientStatus")
    }
  }

  return (
    <div className='toggle-patient'onClick={(e) => e.stopPropagation()}>
      <Switch
        checked={isActive}
        onChange={(checked, event) => handleToggle(checked, event)}
        checkedChildren="Active"
        unCheckedChildren="Inactive"
      />

      <Modal
        visible={isModalVisible}
        footer={null}
        onCancel={() => setIsModalVisible(false)}
        width="45%"
      >
        <Title level={3}>Confirm Deactivation</Title>
        <Text>
          This patient will be deactivated from the system and no longer receive 
          communication or support from MoveAI. Do you wish to continue?
        </Text>
        <div style={{ textAlign: 'right', marginTop: '20px' }}>
          <Button onClick={() => setIsModalVisible(false)} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" danger onClick={handleConfirmDeactivate}>
            Inactive
          </Button>
        </div>
      </Modal>
    </div>
  );
};
const mapStateToProps = (state) => {
    return {
        patient: state.patient.patient,
    }
  }
  
  const mapDispatchToProps = (dispatch) => {
    return {
        togglePatientStatus: (params) => dispatch(togglePatientStatus(params)),
        setActionDisabled: (params) => dispatch(setActionDisabled(params)),
        getPatient: (params) => dispatch(getPatient(params)),
    }
  }

export default connect(mapStateToProps, mapDispatchToProps)(PatientActiveModal)


